// extracted by mini-css-extract-plugin
export var circle = "service-module--circle--ee08a";
export var description = "service-module--description--535ae";
export var icon = "service-module--icon--0ff6d";
export var link = "service-module--link--28c86";
export var service = "service-module--service--d3fd0";